import { createContext, useContext, useEffect } from "react";
import { useProfile } from "@/hooks/useSettings";
import { setCurrencyDecimals } from "@/lib/utils";

const CurrencyContext = createContext<{ decimals: number }>({ decimals: 2 });

export function CurrencyProvider({ children }: { children: React.ReactNode }) {
  const { profile } = useProfile();
  const decimals = (profile as any)?.currency_decimals ?? 2;

  useEffect(() => {
    setCurrencyDecimals(decimals);
  }, [decimals]);

  return (
    <CurrencyContext.Provider value={{ decimals }}>
      {children}
    </CurrencyContext.Provider>
  );
}

export function useCurrencyDecimals() {
  return useContext(CurrencyContext).decimals;
}
